export function MemberDetailSkeleton() {
    return (
        <>
            <div className="flex items-center gap-4">
                <div className="size-10 skeleton-item rounded-full" />
                <div className="flex flex-col gap-2">
                    <div className="h-7 w-40 skeleton-item rounded" />
                    <div className="h-4 w-56 skeleton-item rounded" />
                </div>
            </div>

            <div className="grid grid-cols-2 @wide:grid-cols-4 gap-6">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="flex flex-col gap-2">
                        <div className="h-3 w-20 skeleton-item rounded" />
                        <div className="h-4 w-28 skeleton-item rounded" />
                    </div>
                ))}
            </div>

            <div className="flex flex-col gap-3">
                <div className="h-5 w-36 skeleton-item rounded" />
                <div className="flex flex-col gap-2">
                    {[1, 2, 3, 4].map((i) => (
                        <div
                            key={i}
                            className="skeleton-item-container h-12 rounded"
                        />
                    ))}
                </div>
            </div>
        </>
    );
}
